import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlDuplicateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.95 0.25H10.43C9.44 0.25 8.63 1.06 8.63 2.05V4.44H2.05C1.06 4.44 0.25 5.25 0.25 6.24V21.95C0.25 22.94 1.06 23.75 2.05 23.75H13.57C14.56 23.75 15.37 22.94 15.37 21.95V19.56H21.95C22.94 19.56 23.75 18.75 23.75 17.76V2.05C23.75 1.06 22.94 0.25 21.95 0.25ZM13.87 21.95C13.87 22.11 13.74 22.25 13.57 22.25H2.05C1.89 22.25 1.75 22.12 1.75 21.95V6.24C1.75 6.08 1.88 5.94 2.05 5.94H8.63V17.76C8.63 18.75 9.44 19.56 10.43 19.56H13.87V21.95ZM22.25 17.76C22.25 17.92 22.12 18.06 21.95 18.06H10.43C10.27 18.06 10.13 17.93 10.13 17.76V2.05C10.13 1.89 10.26 1.75 10.43 1.75H21.95C22.11 1.75 22.25 1.88 22.25 2.05V17.76Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlDuplicateIcon.displayName = 'CtrlDuplicateIcon';
